export enum BackendGatewayColEnum {
  SAS_DEV = 'https://sas-v30-dev-dot-stunning-base-164402.appspot.com/',
  SAS = 'https://sas-v30-dot-stunning-base-164402.appspot.com/',
  SAS_QA = 'https://sas-v30-dot-stunning-base-164402.appspot.com/',
  DATA_FOUNDATION = 'https://datafoundation-dot-stunning-base-164402.appspot.com/',
  DATA_FOUNDATION_DEV = 'https://datafoundation-dev-dot-stunning-base-164402.appspot.com/',
  UTILITIES = 'https://ftd-services-utilities-nest-voqp7ipqwq-uc.a.run.app/',
  GATEWAY = 'https://gateway-dot-stunning-base-164402.appspot.com/',
  GATEWAY_CVV = 'https://cvv-address-dot-gateway-dot-stunning-base-164402.uc.r.appspot.com/',
  GATEWAY_CART = 'https://new-car-dot-gateway-dot-stunning-base-164402.appspot.com/',
  SANDBOX_MULTICOUNTRY = 'https://multicountry-apigateway-dot-sandbox-domicilios-farmatodo.uk.r.appspot.com/',
  QA_PSE_MULTICOUNTRY = 'https://qa-pse-dot-multicountry-apigateway-dot-stunning-base-164402.uc.r.appspot.com/',
  BACK3 = 'https://qa-2019-dot-gateway-dot-stunning-base-164402.appspot.com/',
  CMS = 'https://cms-dot-stunning-base-164402.appspot.com/',
  CLOUD_FUNCTION = 'https://us-central1-stunning-base-164402.cloudfunctions.net/',
  DEVELOP = 'https://develop-dot-stunning-base-164402.appspot.com/_ah/api/',
  SANDBOX = 'https://sandbox-mc-dot-multicountry-apigateway-dot-stunning-base-164402.uc.r.appspot.com/_ah/api/',
  CONTINGENCY = 'https://contingency-dot-stunning-base-164402.appspot.com/_ah/api/',
  PROD = 'https://prod-dot-stunning-base-164402.appspot.com/_ah/api/',
  QA = 'https://qa-dot-stunning-base-164402.appspot.com/_ah/api/',
  QA_ENV = 'https://qa-env-dot-stunning-base-164402.appspot.com/_ah/api/',
  QA_ENV_1 = 'https://qa-env1-dot-stunning-base-164402.appspot.com/_ah/api/',
  QA_ENV_2 = 'https://qa-env2-dot-stunning-base-164402.appspot.com/_ah/api/',
  QA_ENV_3 = 'https://qa-env3-dot-stunning-base-164402.appspot.com/_ah/api/',
  MP = 'https://mercado-pago-dot-gateway-dot-stunning-base-164402.uc.r.appspot.com/',
  PRODUCTION = 'https://stunning-base-164402.appspot.com/_ah/api/',
  CO = 'https://gateway-dot-stunning-base-164402.uc.r.appspot.com',
  NOTIFICATIONS = 'https://bra-not-dot-gateway-dot-stunning-base-164402.uc.r.appspot.com/',
    MULTICOUNTRY = 'https://gw-backend.farmatodo.com/',
  OPTICA = 'https://optics-dot-qa-env-dot-sandbox-domicilios-farmatodo.uk.r.appspot.com/',
  OPTICA2 = 'https://optics-dot-multicountry-apigateway-dot-stunning-base-164402.uc.r.appspot.com/',
  PRIME = 'https://pr-dot-multicountry-apigateway-dot-stunning-base-164402.uc.r.appspot.com/',
  LOREAL = 'https://loreal-dot-multicountry-apigateway-dot-stunning-base-164402.uc.r.appspot.com/',
  CRM = 'https://gateway-dot-stunning-base-164402.uc.r.appspot.com/',
  ALGOLIA = 'https://vcojeyd2po-dsn.algolia.net/',
  API_MP = 'https://api.mercadopago.com/',
  MULTI_COUNTRY_SANDBOX = 'https://cuponera-dot-multicountry-apigateway-dot-stunning-base-164402.uc.r.appspot.com/',
  CALL = 'https://login-dot-gateway-dot-stunning-base-164402.uc.r.appspot.com/',
  NEWHOME = 'https://home-dot-multicountry-apigateway-dot-stunning-base-164402.uc.r.appspot.com/',
  MICROCOBROS = 'https://tk-dot-multicountry-apigateway-dot-stunning-base-164402.uc.r.appspot.com/',
  SANBOX_MICROCOBROS = 'https://gateway-dot-sandbox-domicilios-farmatodo.uk.r.appspot.com/',
  COUNTRIES_SELECT = 'https://flagregistries-dot-qa-env3-dot-stunning-base-164402.uc.r.appspot.com/_ah/api/',
  PSE = 'https://pse-pr-dot-multicountry-apigateway-dot-stunning-base-164402.uc.r.appspot.com/',
  TALONONE = 'https://gateway-dot-stunning-base-164402.uc.r.appspot.com/',
  PRIME_FREE = 'https://blue-dot-gateway-dot-sandbox-domicilios-farmatodo.uk.r.appspot.com/',
  PILL_REMINDER = 'https://pill-dot-utilities-dot-stunning-base-164402.uc.r.appspot.com/',
  TALONONE_DISCOUNTS = 'https://soap-4-dot-gateway-dot-sandbox-domicilios-farmatodo.uk.r.appspot.com/',
  TALONONE_DISCOUNTS_PROD = 'https://petals-dot-gateway-dot-stunning-base-164402.uc.r.appspot.com/',
  MONITOR = 'https://gw-backend.farmatodo.com/monitor-reports/v3/',
  CREATE_ORDER_V2 = 'https://corder-dot-multicountry-apigateway-dot-stunning-base-164402.uc.r.appspot.com/',
  YUNO = 'https://gw-backend.farmatodo.com/',
  BACKEND_MULTICOUNTRY = 'https://api-transactional.farmatodo.com/',
  BACKEND_MULTICOUNTRY_DEV = 'https://api-transactional-dev.farmatodo.com/',
  BACKEND_MULTICOUNTRY_QA = 'https://api-transactional-qa.farmatodo.com/',
  API_OPERATIONAL = 'https://api-operational.farmatodo.com/',
  COURIER= 'https://ftd-td-marketplace-courier-write-services-voqp7ipqwq-uc.a.run.app/',
  MARKETPLACE_ORDER= 'https://ftd-td-marketplace-order-read-services-voqp7ipqwq-uc.a.run.app/',
  RECAPTCHA = 'https://recaptcha-co.farmatodo.com/',
  GATEWAYDATA = 'https://data-analytics.farmatodo.com.co/'            
}